import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatApiError = (detail) => {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return typeof detail?.msg === "string" ? detail.msg : String(detail);
};

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blueprint flex min-h-screen flex-col bg-[var(--stone)]">
      <div className="px-5 py-5 sm:px-8"><Link to="/" data-testid="admin-login-home-link"><Logo /></Link></div>
      <div className="flex flex-1 items-center justify-center px-5 pb-20">
        <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-[2px] border border-[var(--line)] bg-white/80 p-8 backdrop-blur-xl sm:p-10">
          <p className="eyebrow">Intern</p>
          <h1 className="font-serif-d mt-4 text-4xl tracking-tight">Anfragen-Übersicht</h1>
          <p className="mt-2 text-sm text-[var(--ink-2)]">Nur für Sanaz und Ghassem.</p>
          <label className="mt-8 block">
            <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[var(--ink-2)]">E-Mail</span>
            <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full border-0 border-b border-[var(--ink)]/25 bg-transparent py-3 text-lg outline-none focus:border-[var(--clay)]" />
          </label>
          <label className="mt-6 block">
            <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[var(--ink-2)]">Passwort</span>
            <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full border-0 border-b border-[var(--ink)]/25 bg-transparent py-3 text-lg outline-none focus:border-[var(--clay)]" />
          </label>
          {error && <p data-testid="admin-login-error" className="mt-5 text-sm text-[#B42318]">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="group mt-8 flex w-full items-center justify-between rounded-full bg-[var(--ink)] py-2 pl-6 pr-2 text-sm text-[var(--stone)] transition-[background-color] duration-300 hover:bg-[var(--clay)] disabled:opacity-60">
            Anmelden
            <span className="grid h-10 w-10 place-items-center rounded-full bg-[var(--stone)] text-[var(--ink)] transition-transform duration-500 group-hover:rotate-45">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowUpRight className="h-4 w-4" />}
            </span>
          </button>
        </form>
      </div>
    </div>
  );
}
